import { ResponseInterceptor } from '@tencent/iegsp-common/tools/utils/login/interceptor';
import { LoginInfoInterceptor } from './loginInfoInterceptor';

import { request, initNetworkManager, addInterceptors } from '@tencent/iegsp-common/request';
import { ITipInterceptor, ITipRequestParam } from '@tencent/pmd-types';

/**
 * 自定义超时拦截器
 * 覆盖公共库默认的 180s 超时时间，改为 10分钟
 * 原理：先于 RequestInterceptor 执行，设置 axiosParam.timeout，
 * RequestInterceptor 内部通过 ...param.extra?.axiosParam 展开时会保留此值
 */
class TimeoutInterceptor implements ITipInterceptor {
  interceptor(param: ITipRequestParam): [boolean, any] {
    param.extra = {
      ...param.extra,
      axiosParam: {
        timeout: 10 * 60 * 1000,
        ...param.extra?.axiosParam,
      },
    };
    return [false, param];
  }
}

addInterceptors('requestInterceptors', [new TimeoutInterceptor()]);
addInterceptors('responseInterceptors', [new LoginInfoInterceptor(), new ResponseInterceptor()]);

export { request, initNetworkManager };
